import AmexGDAHeader from './AmexGDAHeader';

export default AmexGDAHeader;
